import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankStatementThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 66,
	height: 81,
	viewBox: "0 0 66 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6311_41006)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter1_d_6311_41006)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M56.6208 3H9.37838C8.06484 3 7 4.06296 7 5.37419V67.7259C7 69.0371 8.06484 70.1001 9.37838 70.1001H56.6208C57.9344 70.1001 58.9992 69.0371 58.9992 67.7259V5.37419C58.9992 4.06296 57.9344 3 56.6208 3Z",
						fill: "white"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M56.6209 3.14844H9.37841C8.14697 3.14844 7.14868 4.14497 7.14868 5.37424V67.7259C7.14868 68.9552 8.14697 69.9517 9.37841 69.9517H56.6209C57.8523 69.9517 58.8506 68.9552 58.8506 67.7259V5.37424C58.8506 4.14497 57.8523 3.14844 56.6209 3.14844Z",
						stroke: "#D0D5DD",
						strokeWidth: .5
					})]
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 24.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 29.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 34.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 39.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 44.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 49.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.9727,
					y: 54.9097,
					width: 41,
					height: 3,
					rx: 1,
					fill: "#E4E8EA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9727 8.90967L26.9727 8.90967",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9727 16.9097L30.9727 16.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9727 21.9097L44.9727 21.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9727 62.9097L43.9727 62.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.9727 8.90967L52.9727 8.90967",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6311_41006",
			x: .898682,
			y: .898438,
			width: 64.2019,
			height: 79.3032,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_41006"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_41006",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_6311_41006",
			x: .898682,
			y: .898438,
			width: 64.2019,
			height: 79.3032,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_41006"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_41006",
					result: "shape"
				})
			]
		})] })
	]
});
export default SvgBankStatementThumbnail;
